angular.module('impactx.catalogruleresult').controller('CatalogRuleProductLabelStatisticListCtrl',
    CatalogRuleProductLabelStatisticListCtrl);

CatalogRuleProductLabelStatisticListCtrl.$inject = ['$routeParams', 'selectedListItems', 'OneTimeDataTransporter'];

function CatalogRuleProductLabelStatisticListCtrl($routeParams, selectedListItems, OneTimeDataTransporter)
{
    var idOfResultLink = 0;
    var resultLink = null;
    var self = this;

    this.redirectToProductList = function (event, trns, additionalFields) {
        if (selectedListItems.getFirstSelectedItem()) {
            if (selectedListItems.getFirstSelectedId() !== idOfResultLink) {
                var redirect = additionalFields.checkedOut ? "checkedoutcataloglist" : "checkedincataloglist";
                resultLink = redirect + "/" + additionalFields.catId + "/productLabelKey/" + selectedListItems.getFirstSelectedItem().productLabelKey + "/" + selectedListItems.getFirstSelectedItem().number;
                idOfResultLink = selectedListItems.getFirstSelectedId();
            }
            OneTimeDataTransporter.setAndRedirect({cmrlName: selectedListItems.getFirstSelectedItem().description}, null, resultLink);
        }
    };

    var buttonDefinition = [
        {label: "products", action: self.redirectToProductList, condition: selectedListItems.isSingleSelection, process: 'CatalogRule'}
    ];

    this.meta = {
        rowTemplate: 'modules/catalogruleresult/templates/catalogruleproductlabelstatisticlist.row.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/catalogruleresult/ruleproductlabelstatistic',
        id: "catalogruleproductlabelstatisticlist",
        params: {'cmrliId': $routeParams.id},
        excelParams: {
            params: [{param: 'CMRLIId', intValue: $routeParams.id}]
        },
        buttonDefinition: buttonDefinition,
        excelExport: true
    };
    this.getMeta = function () {
        return this.meta;
    }
}